import React from "react";

const SheaButterHairSpaWhat = () => {
  return (
    <div className="hairSalonInSahakaraWhat">
      <h3>What to Expect During a Shea Butter Hair Spa Session at SCENT</h3>
      <p>
        Our Shea Butter Hair Spa in Bangalore is a step-by-step process that
        ensures maximum benefits for your hair and scalp:
      </p>
      <li>
        <h6>1. Consultation:</h6>
        <p>
          Our hair care experts analyze your hair type, texture, and specific
          concerns to tailor the treatment to your needs.
        </p>
      </li>
      <li>
        <h6>2. Gentle Cleansing:</h6>
        <p>
          A mild shampoo removes dirt, oil, and product buildup, preparing your
          hair for the spa treatment.
        </p>
      </li>
      <li>
        <h6>3. Shea Butter Application:</h6>
        <p>
          Warm, nutrient-rich shea butter is applied to your hair and scalp,
          ensuring even coverage.
        </p>
      </li>
      <li>
        <h6> 4. Massage Therapy:</h6>
        <p>
          A relaxing scalp massage stimulates blood circulation, enhances
          absorption, and promotes relaxation.
        </p>
      </li>
      <li>
        <h6> 5. Steam Treatment:</h6>
        <p>
          Gentle steaming opens the hair cuticles, allowing the shea butter to
          penetrate deeply.
        </p>
      </li>
      <li>
        <h6> 6. Rinse and Style:</h6>
        <p>
          After a thorough rinse, your hair is styled to perfection, leaving you
          ready to shine.
        </p>
      </li>
    </div>
  );
};

export default SheaButterHairSpaWhat;
